import { Fade } from 'react-awesome-reveal'
import dynamic from 'next/dynamic'

import { VehicleImage } from '../VehicleImage'
import styles from './vehicle-view.module.scss'
import { TechnicalData, Vehicle } from '@/types/vehicle'
import { constants } from '@/lib/constants'
import { ColourOptionsAlert } from '@/components/views/ConfigPage/ColourOptions/ColourOptionsAlert'
import { Dimensions } from '../Dimensions'
import { useState } from 'react'
import { Size } from '@/types/system'
import { Button, ButtonHierarchy } from '../../Button'

const VehicleDataSpotlightGroup = dynamic(() => import('../VehicleDataSpotlight'))
const Icon = dynamic(() => import('@/components/styleguide/Icon'), { ssr: false })

export type VehicleViewProps = {
  vehicle: Vehicle
  technicalData: TechnicalData
  setActiveSection: (id: string) => void
  activeSection: string
}

export const VehicleView = ({ vehicle, technicalData, setActiveSection, activeSection }: VehicleViewProps) => {
  const [activeImage, setActiveImage] = useState<string>('sideview')

  const onScrollDownClick = () => {
    const specBody = document.getElementById('specification-body')
    specBody?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  return (
    <div className={styles.container}>
      <VehicleImage
        vehicle={vehicle}
        setActiveSection={setActiveSection}
        activeSection={activeSection}
        setActiveImage={setActiveImage}
        activeImage={activeImage}
      />
      {activeSection === constants.configPageSections.COLOUR_OPTIONS &&
        <Fade className={styles.banner} triggerOnce delay={300}>
          <ColourOptionsAlert />
        </Fade>
      }
      {activeSection === constants.configPageSections.SPECIFICATION &&
        <Fade triggerOnce delay={300}>
          <div className={styles.scroll}>
            <Button
              onClick={onScrollDownClick}
              hasBackground={false}
              hasPadding={false}
              hierarchy={ButtonHierarchy.Text}
              size={Size.Medium}>
              <Icon
                name="MoveDown"
                size={Size.Medium}
              />
              <p>
                Scroll
                <br />
                down
              </p>
            </Button>
          </div>
          <Dimensions activeImage={activeImage} technicalData={technicalData} vehicleType={vehicle.type} />
        </Fade>
      }
      {activeSection === constants.configPageSections.OVERVIEW &&
        <Fade className={styles.spotlight} triggerOnce delay={300}>
          <VehicleDataSpotlightGroup
            technicalData={technicalData}
            vehicleFuelType={vehicle.fuelType}
            vehicleType={vehicle.type}
          />
        </Fade>
      }
    </div>
  )
}
